'use strict';

var React = require('react');
var ClassNames = require('classnames');
var Screen = require('../../utils/Screen.js');
var _ = require('lodash');
var ApplicationActions = require('../../actions/ApplicationActions.js');

var ErrorList = React.createClass({
    getInitialState: function() {
        return {
            hideErrorList: true
        };
    },
    gotoSection: function (id) {
        Screen.moveToNextError(id, !this.props.hideErrorBar);
        ApplicationActions.gotoFieldWithError(id);
    },
    showErrorBar: function () {
        ApplicationActions.showErrorBar(true);
    },
    hideErrorBar: function () {
        ApplicationActions.showErrorBar(false);
    },
    componentDidUpdate: function() {
        if (this.state.hideErrorList === true){
            this.hideErrorBar();
        }
    },
    shouldComponentUpdate: function(nextProps) {
        return (!_.isEqual(this.props.errorList, nextProps.errorList) || this.props.hideErrorBar !== nextProps.hideErrorBar);
    },
    render: function () {
        if (this.props.errorList.length > 0) {
            this.state.hideErrorList = false;
        }
        else{
            this.state.hideErrorList = true;
        }

        //TODO : refactor this ,  the id of a tag should change to something else ,  then pass the field ID to this.gotoSection
        var errorList = function (data, index) {
            return (
                <li key={index }>
                    <a className="quiet" onClick={this.gotoSection.bind(this, data.id)}>{data.clickable}</a>: {data.message}
                </li>
            );
        };


        return (
            <div className="app-error-list">
                <div className={ClassNames('form-error', { hidden: this.state.hideErrorList })}>
                    <div className="container">
                    <h3>Oops, looks like we need bit more information before we can continue</h3>
                        <ul>
                            {this.props.errorList.map(errorList, this)}
                        </ul>
                        <button type="button" className={ClassNames('btn btn-default btn-lg', { hidden: !this.props.hideErrorBar })} onClick={this.showErrorBar}>View missing information</button>
                        <button type="button" className={ClassNames('btn btn-default btn-lg', { hidden: this.props.hideErrorBar })} onClick={this.hideErrorBar}>Hide missing information</button>
                    </div>
                </div>
            </div>
		);
    }
});

module.exports = ErrorList;



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/Common/ErrorList.jsx